import { useCallback, useEffect, useState } from 'react';
import { getHistoricoMedicacoes } from '../../api/api';

/**
 * Hook para buscar histórico de medicações com filtros opcionais.
 */
export function useHistoricoMedicacoes(pacienteId, options = {}) {
    const { limit = 100, startDate = null, endDate = null } = options;
    
    const [data, setData] = useState({
        planos_ativos: [],
        planos_inativos: [],
        tarefas_executadas: [],
        total_planos: 0,
        total_tarefas: 0
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!pacienteId) return;
        
        setIsLoading(true);
        setError(null);
        
        try {
            const response = await getHistoricoMedicacoes(pacienteId, { limit, startDate, endDate });
            const historico = response?.data?.data || response?.data || {};
            
            setData({
                planos_ativos: historico.planos_ativos || [],
                planos_inativos: historico.planos_inativos || [],
                tarefas_executadas: historico.tarefas_executadas || [],
                total_planos: historico.total_planos || 0,
                total_tarefas: historico.total_tarefas || 0
            });
        } catch (err) {
            setError(err?.response?.data?.message || err?.message || 'Erro ao carregar histórico de medicações.');
        } finally {
            setIsLoading(false);
        }
    }, [pacienteId, limit, startDate, endDate]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const refetch = useCallback(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        isLoading,
        error,
        refetch
    };
}

export default useHistoricoMedicacoes;

